// src/api/apiClient.js
import axios from 'axios';

// URL base del backend JCB (Laravel)
// Desarrollo: http://127.0.0.1:8000/jcb
// Producción: define REACT_APP_JCB_URL en tu .env
const JCB_BASE_URL =
  // process.env.REACT_APP_JCB_URL || 'http://127.0.0.1:8000/jcb';
  process.env.REACT_APP_JCB_URL || 'https://appjcb.azteca-site.org/jcb';

const jcbClient = axios.create({
  baseURL: JCB_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Interceptor de respuesta: log legible en desarrollo
jcbClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(
        `[JCB ${error.response?.status || 'ERR'}]`,
        error.config?.method?.toUpperCase(),
        error.config?.url,
        error.response?.data || error.message
      );
    }
    return Promise.reject(error);
  }
);

// Helper corto para no repetir la instancia
// Uso:  jcb.get('/spare-parts/filters')
//       jcb.get('/spare-parts/search', { searchType, ... })
//       jcb.post('/quotes', data)
export const jcb = {
  get: (url, params) => jcbClient.get(url, { params }),
  post: (url, data) => jcbClient.post(url, data),
  put: (url, data) => jcbClient.put(url, data),
  patch: (url, data) => jcbClient.patch(url, data),
  delete: (url) => jcbClient.delete(url),
};

export default jcbClient;